import { Footer as AuroraFooter, LogoPrimaryCP } from '@consumidor-positivo/aurora';

export const Footer = () => {
  return (
    <AuroraFooter
      certificates={['sslblindado', 'reclameaqui']}
      copyrights={
        <>
          © Copyright 2025 Consumidor Positivo Ltda. <br />
          Todos os direitos reservados / CNPJ: 30.247.128/0001-15
        </>
      }
      logo={<LogoPrimaryCP />}
      socialLinks={{
        facebook: 'https://facebook.com',
        instagram: 'https://instagram.com',
        linkedin: 'https://linkedin.com',
        youtube: 'https://youtube.com',
      }}
    />
  );
};
